import axiosClient from '../../../config/axios-client'

const getCountries = async () => {
  try {
    const { data } = await axiosClient.get('/platform/countries')
    return data.countries
  } catch (error) {
    throw error
  }
}

export { getCountries }
